import React from 'react';

const Toolbar = ({ onGenerateScript }) => (
  <div className="toolbar">
    <button 
      className="tool-btn"
      onClick={onGenerateScript}
      type="button"
    >
      生成视频脚本
    </button>
  </div>
);

export default Toolbar; 